import { render } from "./addSite.vue?vue&type=template&id=0c53c646"
import script from "./addSite.vue?vue&type=script&lang=js"
export * from "./addSite.vue?vue&type=script&lang=js"

import exportComponent from "E:\\case\\要点传达商城\\6-5\\eshop-vant4-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__